const PREFIX = 'tabs';

export const SPARTAN_TABS_TRACKING = {
  root: PREFIX,
  item: (index: number) => `${PREFIX}-item-${index + 1}`,
} as const;
